var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/product-image.j2"] = require( "macros/product-image.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/macros/product-video.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/product-image.j2", false, "product/templates/macros/product-video.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("getSlug")) {
var t_4 = t_1.getSlug;
} else {
cb(new Error("cannot import 'getSlug'")); return;
}
context.setVariable("getSlug", t_4);
if(t_1.hasOwnProperty("productImageSrc")) {
var t_5 = t_1.productImageSrc;
} else {
cb(new Error("cannot import 'productImageSrc'")); return;
}
context.setVariable("productImageSrc", t_5);
var macro_t_6 = runtime.makeMacro(
["imageUrl", "videoUrl", "imageStyle", "colorCode", "carouselCode"], 
["preset", "videoHeight", "class", "type", "autoplay", "showControls", "fit", "hideDownload"], 
function (l_imageUrl, l_videoUrl, l_imageStyle, l_colorCode, l_carouselCode, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("imageUrl", l_imageUrl);
frame.set("videoUrl", l_videoUrl);
frame.set("imageStyle", l_imageStyle);
frame.set("colorCode", l_colorCode);
frame.set("carouselCode", l_carouselCode);
frame.set("preset", kwargs.hasOwnProperty("preset") ? kwargs["preset"] : null);
frame.set("videoHeight", kwargs.hasOwnProperty("videoHeight") ? kwargs["videoHeight"] : null);
frame.set("class", kwargs.hasOwnProperty("class") ? kwargs["class"] : "");
frame.set("type", kwargs.hasOwnProperty("type") ? kwargs["type"] : "mp4");
frame.set("autoplay", kwargs.hasOwnProperty("autoplay") ? kwargs["autoplay"] : runtime.contextOrFrameLookup(context, frame, "False"));
frame.set("showControls", kwargs.hasOwnProperty("showControls") ? kwargs["showControls"] : runtime.contextOrFrameLookup(context, frame, "True"));
frame.set("fit", kwargs.hasOwnProperty("fit") ? kwargs["fit"] : "&fit=constrain");
frame.set("hideDownload", kwargs.hasOwnProperty("hideDownload") ? kwargs["hideDownload"] : runtime.contextOrFrameLookup(context, frame, "True"));
var t_7 = "";var t_8;
t_8 = (lineno = 24, colno = 28, runtime.callWrap(t_4, "getSlug", context, [l_imageStyle,l_colorCode,l_carouselCode]));
frame.set("videoSlug", t_8, true);
if(frame.topLevel) {
context.setVariable("videoSlug", t_8);
}
if(frame.topLevel) {
context.addExport("videoSlug", t_8);
}
if(runtime.contextOrFrameLookup(context, frame, "preset") && runtime.contextOrFrameLookup(context, frame, "videoHeight")) {
var t_9;
t_9 = "?" + "" + runtime.contextOrFrameLookup(context, frame, "preset") + "" + "&hei=" + "" + runtime.contextOrFrameLookup(context, frame, "videoHeight");
frame.set("sizePreset", t_9, true);
if(frame.topLevel) {
context.setVariable("sizePreset", t_9);
}
if(frame.topLevel) {
context.addExport("sizePreset", t_9);
}
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "preset")) {
var t_10;
t_10 = "?" + "" + runtime.contextOrFrameLookup(context, frame, "preset");
frame.set("sizePreset", t_10, true);
if(frame.topLevel) {
context.setVariable("sizePreset", t_10);
}
if(frame.topLevel) {
context.addExport("sizePreset", t_10);
}
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "videoHeight")) {
var t_11;
t_11 = "?hei=" + "" + runtime.contextOrFrameLookup(context, frame, "videoHeight");
frame.set("sizePreset", t_11, true);
if(frame.topLevel) {
context.setVariable("sizePreset", t_11);
}
if(frame.topLevel) {
context.addExport("sizePreset", t_11);
}
;
}
else {
var t_12;
t_12 = "";
frame.set("sizePreset", t_12, true);
if(frame.topLevel) {
context.setVariable("sizePreset", t_12);
}
if(frame.topLevel) {
context.addExport("sizePreset", t_12);
}
;
}
;
}
;
}
t_7 += "<video\n        src=\"";
t_7 += runtime.suppressValue((lineno = 37, colno = 29, runtime.callWrap(t_5, "productImageSrc", context, [l_videoUrl,runtime.contextOrFrameLookup(context, frame, "videoSlug")])), env.opts.autoescape);
t_7 += ".";
t_7 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "type"), env.opts.autoescape);
t_7 += runtime.suppressValue(env.getFilter("safe").call(context, runtime.contextOrFrameLookup(context, frame, "sizePreset")), env.opts.autoescape);
t_7 += "\"\n        poster=\"";
t_7 += runtime.suppressValue((lineno = 38, colno = 32, runtime.callWrap(t_5, "productImageSrc", context, [l_imageUrl,runtime.contextOrFrameLookup(context, frame, "videoSlug")])), env.opts.autoescape);
t_7 += runtime.suppressValue(env.getFilter("safe").call(context, runtime.contextOrFrameLookup(context, frame, "sizePreset")), env.opts.autoescape);
t_7 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "fit"), env.opts.autoescape);
t_7 += "\"\n        class=\"";
t_7 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "class"), env.opts.autoescape);
t_7 += "\"\n        type=\"video/";
t_7 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "type"), env.opts.autoescape);
t_7 += "\"\n        ";
if(runtime.contextOrFrameLookup(context, frame, "videoHeight")) {
t_7 += "height=\"";
t_7 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "videoHeight"), env.opts.autoescape);
t_7 += "\"";
;
}
t_7 += "\n        ";
if(runtime.contextOrFrameLookup(context, frame, "autoplay")) {
t_7 += "autoplay";
;
}
t_7 += "\n        ";
if(runtime.contextOrFrameLookup(context, frame, "showControls")) {
t_7 += "controls";
;
}
t_7 += "\n        ";
if(runtime.contextOrFrameLookup(context, frame, "hideDownload")) {
t_7 += "controlsList=\"nodownload\"";
;
}
t_7 += "\n        data-tracking-slug=\"";
t_7 += runtime.suppressValue(l_imageStyle, env.opts.autoescape);
t_7 += "_";
t_7 += runtime.suppressValue(l_colorCode, env.opts.autoescape);
t_7 += "\"\n        data-analytics-title=\"";
t_7 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "videoSlug"), env.opts.autoescape);
t_7 += "\"\n        data-analytics-category=\"PAGE_TYPE\"\n        data-qa-product-video\n    ></video>\n";
;
frame = frame.pop();
return new runtime.SafeString(t_7);
});
context.addExport("productVideo");
context.setVariable("productVideo", macro_t_6);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/macros/product-video.j2"] , dependencies)